export default __webpack_public_path__ + "static/media/logo_home.7ceee727.svg";